import classes from "./Careers.module.scss";
import home2 from "../../assets/imgs/careers-intro.png";
import routes from "../../requests/routes";
import axios from "../../requests/axios";
import { useEffect, useState } from "react";

const JOBS = [
  {
    id: "travel-consultant",
    title: "Travel Consultant",
    location: "Cairo, Egypt (Hybrid)",
    type: "Full-time",
    summary:
      "Advise clients and craft personalized itineraries across leisure and corporate segments.",
    description:
      "You’ll guide travelers from inspiration to touchdown: consult on destinations, curate multi‑leg itineraries, secure bookings, and handle on‑trip support. You’ll collaborate with tour ops, airline partners, and DMCs to deliver unforgettable experiences that fit budget, style, and timeline.",
    qualifications: [
      "2+ years in travel planning, agency, or hospitality",
      "Fluent English; Arabic a plus",
      "Experience with GDS (Amadeus/Sabre) or OTA tools",
      "Strong customer empathy and problem‑solving",
    ],
    benefits: [
      "Competitive salary + quarterly bonus",
      "Annual learning stipend",
      "Travel discounts & familiarization trips",
      "Flexible work policy",
    ],
  },
  {
    id: "tours-ops-coordinator",
    title: "Tour Operations Coordinator",
    location: "Remote (EMEA)",
    type: "Full-time",
    summary:
      "Own the operational backbone: vendor coordination, confirmations, manifests, and on‑ground logistics.",
    description:
      "Work closely with guides, hotels, and transport partners to confirm services, maintain manifests, and respond to day‑of changes. You’ll keep our departures smooth and our guests delighted.",
    qualifications: [
      "1–3 years in operations or logistics",
      "Meticulous with docs and timelines",
      "Comfort with spreadsheets and CRM",
      "Calm under pressure and after‑hours escalations",
    ],
    benefits: [
      "Remote‑friendly setup",
      "Private medical insurance",
      "Paid time off and local holidays",
      "Annual team retreat",
    ],
  },
  {
    id: "marketing-partnerships-manager",
    title: "Marketing & Partnerships Manager",
    location: "Cairo, Egypt",
    type: "Full-time",
    summary:
      "Grow our brand through content, influencers, and destination partnerships.",
    description:
      "Lead integrated campaigns across paid, owned, and earned channels. Develop co‑marketing with airlines and tourism boards, and track ROI from top‑funnel to bookings.",
    qualifications: [
      "4+ years in marketing or growth",
      "Strong copy and storytelling skills",
      "Experience managing partner relationships",
      "Familiarity with analytics tools (GA4/Looker)",
    ],
    benefits: [
      "Performance bonus",
      "Device & home office stipend",
      "Commuter benefits",
      "Parent‑friendly leave policy",
    ],
  },
];

export const CareersPage = () => {
  const [careers, setCareers] = useState([]);

  async function getCareers() {
    try {
      const response = await axios.get(routes.getAllCareers);
      setCareers(response.data.careers);
      setLoading(false);
    } catch (err) {}
  }
  useEffect(() => {
    getCareers();
  }, []);

  const mailto = (jobTitle) =>
    `mailto:careers@have-adream.com?subject=${encodeURIComponent(
      `Application: ${jobTitle}`,
    )}&body=${encodeURIComponent(
      `Hi have-adream com,%\n\nI'm applying for the ${jobTitle} role.\n\n— Your Name`,
    )}`;

  return (
    <section className={classes.careers} id="main-content">
      <section className={`banner`}>
        <div className={`banner__overlay`}>
          <div className={`banner__pattern`} aria-hidden="true" />
          <div className={`banner__body`}>
            <h2 className={`banner__body__title`}>
              Explore Exciting Career <span>Opportunities</span> with Us
            </h2>
            <p className={`banner__body__text`}>
              We’re always looking for talented, passionate people to join our
              team. If you’re excited about travel and delivering exceptional
              experiences.
            </p>
          </div>
        </div>
      </section>

      <section className={classes.careers__intro}>
        <figure className={`${classes.careers__intro__media}`}>
          <img
            className={`${classes.careers__intro__media__img}`}
            src={home2}
            loading="lazy"
          />
        </figure>
        <div className={classes.careers__intro__body}>
          <h2 className={classes.careers__intro__body__title}>
            Diversity, Equity & Inclusion
          </h2>
          <p className={classes.careers__intro__body__text}>
            At have a dream, we believe that travel has the power to transform
            lives. As a member of our team, you’ll play a key role in helping
            people see the world in a new way. We’re passionate about creating
            unforgettable experiences for our clients, and we’re looking for
            like-minded individuals to join us on this journey.
          </p>
        </div>
      </section>

      <header
        className={classes.careers__header}
        aria-labelledby="careers-title"
      >
        <h2 id="careers-title" className={classes.careers__header__title}>
          Interested in our mission?
        </h2>
        <p className={classes.careers__header__subtitle}>
          Help people see the world—join our growing, traveler‑first team.
        </p>
      </header>

      <section className={classes.careers__list} aria-label="Open positions">
        {careers.map((job) => (
          <article
            className={classes.job}
            key={job.id}
            itemScope
            itemType="https://schema.org/JobPosting"
          >
            <div className={classes.job__header}>
              <h2 className={classes.job__title} itemProp="title">
                {job.title}
              </h2>
              <div className={classes.job__meta}>
                <span className={classes.job__badge} itemProp="employmentType">
                  {job.employmentType}
                </span>
                <span className={classes.job__dot} aria-hidden>
                  •
                </span>
                <span className={classes.job__location} itemProp="jobLocation">
                  {job.location}
                </span>
              </div>
            </div>

            <p className={classes.job__summary} itemProp="description">
              {job.summary}
            </p>

            <details className={classes.job__details}>
              <summary
                className={classes.job__toggle}
                aria-label={`Toggle details for ${job.title}`}
              >
                Job details
              </summary>

              {job.description && (
                <section className={classes.job__section}>
                  <h3 className={classes.job__sectionTitle}>Description</h3>
                  <p
                    className={classes.job__section__desc}
                    dangerouslySetInnerHTML={{ __html: `${job.description}` }}
                  ></p>
                </section>
              )}

              {job.keyResponsibilities?.length > 0 && (
                <section className={classes.job__section}>
                  <h3 className={classes.job__sectionTitle}>
                    Key Responsibilities
                  </h3>
                  <ul className={classes.job__list}>
                    {job.keyResponsibilities.map((responsibility, i) => {
                      if (typeof responsibility === "string") {
                        return <li key={i}>{responsibility}</li>;
                      }

                      return (
                        <li key={i}>
                          <strong>{responsibility.title}</strong>
                          {responsibility.description
                            ? `: ${responsibility.description}`
                            : ""}
                        </li>
                      );
                    })}
                  </ul>
                </section>
              )}

              {job.qualifications?.length > 0 && (
                <section className={classes.job__section}>
                  <h3 className={classes.job__sectionTitle}>Qualifications</h3>
                  <ul className={classes.job__list}>
                    {job.qualifications.map((q, i) => (
                      <li key={i}>{q}</li>
                    ))}
                  </ul>
                </section>
              )}

              {job.benefits?.length > 0 && (
                <section className={classes.job__section}>
                  <h3 className={classes.job__sectionTitle}>Benefits</h3>
                  <ul className={classes.job__list}>
                    {job.benefits.map((b, i) => (
                      <li key={i}>{b}</li>
                    ))}
                  </ul>
                </section>
              )}
            </details>

            <div className={classes.job__actions}>
              <a
                className={`${classes.btn} ${classes.btn__primary}`}
                href={job.applicationUrl}
                target="_blank"
                rel="noreferrer noopener"
              >
                Apply Now
              </a>
              {/* <a
                className={`${classes.btn} ${classes.btn__ghost}`}
                href={`https://www.linkedin.com/shareArticle?mini=true&title=${encodeURIComponent(
                  job.title
                )}`}
                target="_blank"
                rel="noreferrer noopener"
              >
                Share
              </a> */}
            </div>
          </article>
        ))}
      </section>

      {/* Empty state example (show if JOBS.length === 0) */}
      {JOBS.length === 0 && (
        <section
          className={classes.careers__empty}
          role="status"
          aria-live="polite"
        >
          <h2>No open roles right now</h2>
          <p>
            We’re always keen to meet great people. Send your CV to{" "}
            <a href="mailto:careers@have-adream.com">careers@have-adream.com</a>
            .
          </p>
        </section>
      )}
    </section>
  );
};

export default CareersPage;
